<!-- Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved. -->

<template>
  <div class="container">
    <h2>{{ app }}</h2>
    <h5>{{ $t("auth.unauthorized.unauthorized") }}</h5>
    <p>{{ $t("auth.unauthorized.contactHelpDesk") }}</p>
  </div>
</template>

<script lang="ts">
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'unauthorized',
  props: {
    app: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  margin-bottom: 20px;
}

h5 {
  color: $red;
}
</style>
